import enviro from 'enviro';
import { parse } from 'hub-http/helpers/params';
export const getQueryParam = param => {
  // Accessing `window.top` throws when we're on a
  // different domain (e.g. Wordpress)
  try {
    return parse(window.top.location.search.substring(1))[param];
  } catch (_) {
    return '';
  }
};
export const getHasAcceptanceTestOverride = () => {
  return getQueryParam('isAcceptanceTest') === 'true';
};
export const HAS_ASSIGNABLE_OVERRIDE = getQueryParam('assignable') === 'true' && (enviro.isQa() || getHasAcceptanceTestOverride());
export const HAS_UNASSIGNABLE_OVERRIDE = getQueryParam('assignable') === 'false' && (enviro.isQa() || getHasAcceptanceTestOverride());
export const HAS_RETAIL_OVERRIDE = getQueryParam('isRetail') === 'true' && (enviro.isQa() || getHasAcceptanceTestOverride());
export const HAS_NOT_RETAIL_OVERRIDE = getQueryParam('isRetail') === 'false' && (enviro.isQa() || getHasAcceptanceTestOverride());
export const HAS_FREE_OVERRIDE = getQueryParam('isFree') === 'true' && (enviro.isQa() || getHasAcceptanceTestOverride());
export const HAS_PAID_OVERRIDE = getQueryParam('isFree') === 'false' && (enviro.isQa() || getHasAcceptanceTestOverride());